import { RegisterDog } from "container/OnBoarding/RegisterDog";
import { RegisterMember } from "container/OnBoarding/RegisterMember";
import { MakePayment } from "container/OnBoarding/MakePayment";
import { Route, Routes } from "react-router-dom";

export const MemberRoutes = () => {
  return (
    <Routes>
      <Route path="/registerMember" element={<RegisterMember />} />
      <Route path="/registerDog" element={<RegisterDog />} />
      <Route path="/makePayment" element={<MakePayment />} />
    </Routes>
  );
};
